export const variantMapping = {
  'body-24-bold': {
    fontSize: '24px',
    lineHeight: '32px',
    letterSpacing: '-0.4px',
    fontWeight: 700,
  },
  'body-14-medium': {
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '-0.4px',
  },
  'body-12-regular': {
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '16px',
    letterSpacing: '-0.4px',
  },
  'body-14-regular': {
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '-0.4px',
  },
  'body-14-bold': {
    fontWeight: 700,
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '-0.4px',
  },
  'body-16-medium': {
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '-0.4px',
  },
  'body-20-medium': {
    fontWeight: 500,
    fontSize: '20px',
    lineHeight: '28px',
    letterSpacing: '-0.4px',
  },
  'body-20-bold': {
    fontWeight: 700,
    fontSize: '20px',
    lineHeight: '28px',
    letterSpacing: '-0.4px',
  },
};
